import { render, staticRenderFns } from "./LandingPageLike.vue?vue&type=template&id=df4c16e2&"
import script from "./LandingPageLike.vue?vue&type=script&lang=js&"
export * from "./LandingPageLike.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageLike.vue?vue&type=style&index=0&id=df4c16e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports